export class MissingFormFieldsError extends Error {
  public constructor() {
    super('Please complete the missing fields above.');
  }
}
